import { render, staticRenderFns } from "./LiondeskAvatar.vue?vue&type=template&id=53b52997&scoped=true&lang=pug"
import script from "./LiondeskAvatar.vue?vue&type=script&lang=js"
export * from "./LiondeskAvatar.vue?vue&type=script&lang=js"
import style0 from "./LiondeskAvatar.vue?vue&type=style&index=0&id=53b52997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b52997",
  null
  
)

export default component.exports